import { render } from "./UserAdmin.vue?vue&type=template&id=71066b94&scoped=true"
import script from "./UserAdmin.vue?vue&type=script&lang=js"
export * from "./UserAdmin.vue?vue&type=script&lang=js"

import "./UserAdmin.vue?vue&type=style&index=0&id=71066b94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71066b94"]])

export default __exports__